
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'deal-plans-ui',
  currentProjectVersion: 'static-1.2310',
  depVersions: {
  "deal-plans-ui": "static-1.2310",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.505",
  "diff": "static-1.7",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26371",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5995",
  "hs-test-utils": "static-1.8445",
  "hub-http-shared-msw-handlers": "static-1.10781",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11898",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6853",
  "portals-platform-bend-plugin": "static-1.25",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7578",
  "react-colorpicker": "static-2.10618",
  "react-dlb": "static-1.92",
  "react-utils": "static-2.5619",
  "reselect": "static-3.15",
  "rich-text-lib": "static-1.20451",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18502",
  "ui-components-test-utils": "static-1.6035",
  "avatar-components": "static-1.2889",
  "data-fetching-client": "static-1.10052",
  "deal-plans-lib": "static-1.1591",
  "ui-addon-emoji-picker": "static-1.10274",
  "FileManagerLib": "static-1.40357",
  "foundations-assets": "static-1.5293",
  "foundations-components": "static-1.8642",
  "foundations-theming": "static-1.4884",
  "framer-motion": "static-1.82",
  "hub-http": "static-1.6615",
  "hubspot-prosemirror": "static-1.19158",
  "hubspot-url-utils": "static-1.4383",
  "I18n": "static-7.1691",
  "js-cookie": "static-1.18",
  "payment-link-components": "static-1.24304",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1615",
  "quartz-auth": "static-1.1253",
  "quartz-config": "static-1.1356",
  "quartz-core": "static-1.6797",
  "quartz-routing": "static-1.1008",
  "quick-fetch": "static-1.4187",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "rpc-client-utils": "static-1.5073",
  "sanitize-text": "static-1.8563",
  "ui-addon-i18n": "static-1.11553",
  "ui-addon-react-router-dom": "static-1.9935",
  "UIComponents": "static-3.8844",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3855",
  "quartz-webpack": "static-1.3802",
  "bend-plugin-quartz-routing": "static-1.656",
  "customer-data-objects": "static-1.8099",
  "frontend-preferences-client": "static-1.8325",
  "graphql": "static-1.92",
  "laboratory-lib": "static-3.7556",
  "onboarding-scopes": "static-1.6858",
  "seat-types-lib": "static-1.919",
  "ui-addon-opt": "static-4.8779",
  "usage-tracker": "static-1.7719",
  "usage-tracker-core": "static-1.7569",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3556",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "ts-schema": "static-1.4357",
  "webpack-env": "static-1.54",
  "jasmine": "static-4.4715",
  "bender-build-tools": "static-1.3472",
  "hs-story-utils": "static-1.9831",
  "StyleGuideUI": "static-3.512",
  "data-token-picker": "static-1.17028",
  "icons": "static-2.699",
  "PatternValidationJS": "static-1.3294",
  "property-translator": "static-1.5787",
  "reference-resolvers-lite": "static-1.8510",
  "cssUtils": "static-1.1027",
  "HubStyle": "static-2.12205",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6550",
  "react-input-autosize": "static-2.17",
  "SharedI18nStrings": "static-1.186",
  "foundations-components-test-utils": "static-1.6125",
  "ui-addon-draggable": "static-3.5151",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4923",
  "fast-json-stable-stringify": "static-1.4",
  "crm-message-bus": "static-1.43958",
  "property-value-citations": "static-1.3469",
  "ui-business-units-lib": "static-1.9502",
  "ai-components-ui-library": "static-1.9903",
  "audio-components": "static-1.6478",
  "file-manager-components": "static-1.24717",
  "FileManagerCore": "static-1.40216",
  "FileManagerImages": "static-1.37868",
  "quartz-i18n": "static-1.1253",
  "react-virtualized": "static-2.110",
  "redux-thunk": "static-2.83",
  "video-components": "static-1.14319",
  "bend-plugin-foundations-components": "static-1.4911",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2600",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.116",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2924",
  "ui-fonts": "static-1.1160",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3367",
  "foundations-theming-base": "static-1.3869",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.357",
  "content-assistance-lib": "static-1.8330",
  "content-media-capture": "static-1.5651",
  "customer-data-ui-utilities": "static-1.10238",
  "knowledge-content-types": "static-1.8699",
  "ui-shepherd-react": "static-3.10679",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "commerce-tours-lib": "static-1.6764",
  "customer-data-properties": "static-1.52855",
  "getting-started-shared-tasks": "static-1.19437",
  "growth-onboarding-reliability": "static-1.5489",
  "onboarding-tours": "static-1.17288",
  "sales-checkout-service-client": "static-1.3936",
  "ui-addon-iframeable": "static-1.9485",
  "user-context": "static-1.5476",
  "pdf-js": "static-2.49",
  "interframe": "static-3.5148",
  "usage-tracker-multi": "static-1.6133",
  "hubspotter-http-shared-msw-handlers": "static-1.10779",
  "opentelemetry-fe-types": "static-1.190",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.565",
  "quartz-head": "static-1.1243",
  "quartz-test": "static-1.1253",
  "quartz-tracking": "static-1.957",
  "trellis-components": "static-1.2943",
  "usage-tracker-container": "static-1.7709",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "bend-plugin-chirp-manifest": "static-1.483",
  "chirp-fetch": "static-1.2306",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4877",
  "inbound-db-properties-service-client": "static-1.4105",
  "superstore": "static-1.5164",
  "feedback-loader": "static-1.29955",
  "sassPrefix": "static-1.295",
  "batch-promise": "static-1.1951",
  "external-options-client-types": "static-1.4405",
  "framework-data-schema-resolvers": "static-1.7302",
  "foundations-components-legacy": "static-1.1667",
  "purchase-motions-api": "static-1.6553",
  "signup-constants": "static-1.19809",
  "signup-ui-url-generator": "static-2.8465",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.81",
  "restore-request-side-panel-lib": "static-1.1886",
  "crm-links": "static-1.6708",
  "customer-data-objects-ui-components": "static-1.13435",
  "hs-resources": "static-1.601",
  "inbound-db-meta-service-client": "static-1.3737",
  "pulse": "static-1.1044",
  "smart-property-lib": "static-1.8503",
  "atom": "static-1.5484",
  "magpie-lib": "static-1.5842",
  "navigation-messaging": "static-1.8360",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.8586",
  "chatspot-core": "static-1.23444",
  "ContentUtils": "static-1.69322",
  "copilot-toolkit": "static-1.12022",
  "breeze-engine-lib": "static-1.1982",
  "apollo-link-hub-http": "static-2.5018",
  "immer": "static-1.104",
  "immerable": "static-1.4549",
  "poll-commands": "static-1.3878",
  "breeze-artifacts-sdk": "static-1.648",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.665",
  "ui-universal-auth": "static-1.9600",
  "urlinator": "static-1.4922",
  "video-embed": "static-1.36809",
  "content-icons-ui": "static-1.2417",
  "social-insights-client-types": "static-1.22812",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1386",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29485",
  "content-media-composition-data-lib": "static-1.13455",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4831",
  "react-dnd-compat": "static-1.5018",
  "react-immutable-render-mixin": "static-1.9",
  "content-media-compositions": "static-2.17462",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5302",
  "media-bridge-lib": "static-1.19542",
  "commerce-products-lib": "static-1.10741",
  "growth-data-modal": "static-1.6032",
  "hubspot-apollo-client": "static-1.5280",
  "onboarding-tours-client": "static-1.5503",
  "calling-global-api": "static-1.65940",
  "calling-internal-common": "static-1.31728",
  "calling-lifecycle-internal": "static-1.67322",
  "calling-lifecycle-messages": "static-1.59615",
  "conditional-properties-service-client": "static-1.4079",
  "crm-index-visualization-core": "static-1.4665",
  "crm-pipelines-api-client-types": "static-1.4410",
  "customer-data-properties-shared-msw-handlers": "static-1.10108",
  "customer-data-property-utils": "static-1.8463",
  "formula-editor": "static-1.14920",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4486",
  "meetings-icalendar-utils-lib": "static-1.1043",
  "multi-currency-client-types": "static-1.3974",
  "object-builder-ui-client": "static-1.49889",
  "pipeline-validation-client-types": "static-1.4246",
  "smart-data-capture-core": "static-1.328",
  "tiered-pricing": "static-1.2121",
  "topics-actions-lib": "static-1.581",
  "trial-components-library": "static-1.14279",
  "ui-addon-form-validation": "static-1.11337",
  "zustand": "static-1.87",
  "growth-onboarding-confetti": "static-1.3470",
  "growth-onboarding-next-action-utils": "static-1.2865",
  "navigation-components": "static-1.19033",
  "onboarding-tours-utils": "static-1.1355",
  "ui-shepherd-tracker": "static-1.8060",
  "getting-started-shared-tasks-store": "static-1.18555",
  "usage-tracker-anonymous": "static-1.6136",
  "usage-tracker-public": "static-1.7530",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.107",
  "usage-tracker-session-replay": "static-1.5405",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "nudge-client-utils": "static-1.3296",
  "fdsr-migration-layer": "static-1.421",
  "framework-builder-read-service-client": "static-1.4285",
  "framework-data-schema-quick-fetch": "static-1.7207",
  "persist-promise": "static-1.4108",
  "location-customization-utils-lib": "static-1.10294",
  "event-emitter": "static-1.1365",
  "bend-plugin-pulse": "static-1.547",
  "fast-json-patch": "static-1.73",
  "data-agent-kit": "static-1.790",
  "markdown-it": "static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10864",
  "fsm": "static-1.4160",
  "policy-lib": "static-1.7212",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10927",
  "reactive-lib": "static-1.1128",
  "simple-logging-lib": "static-1.3458",
  "cms-field-types": "static-1.5218",
  "integrations-lib": "static-1.17275",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.960",
  "breeze-engine-core": "static-1.1260",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "unified-auth-core-lib": "static-1.1396",
  "outpost": "static-1.4541",
  "growth-onboarding-feedback-components": "static-1.6990",
  "commerce-permissions": "static-1.1183",
  "customer-data-tracking": "static-1.7278",
  "products-iframe-lib": "static-1.8759",
  "products-ui-components-shared-msw-handlers": "static-1.11163",
  "onboarding-data-sync-lib": "static-1.2717",
  "hubspot-apollo-cache": "static-1.739",
  "calling-error-reporting": "static-1.31735",
  "shared-worker-versioning": "static-1.11446",
  "calling-usage-tracker": "static-1.6942",
  "voice-sms-access-library": "static-1.2290",
  "conversations-skeleton-state": "static-1.7602",
  "crm-index-associations-lib": "static-1.6853",
  "sales-views-client-types": "static-1.4664",
  "bark-lib": "static-1.16936",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6295",
  "react-codemirror": "static-1.11046",
  "embedded-academy-lib": "static-1.15803",
  "hubs-service-types": "static-1.1669",
  "growth-onboarding-next-action-components": "static-1.2893",
  "user-context-client": "static-1.4915",
  "nest": "static-1.642",
  "amplitude-session-replay-browser": "static-1.60",
  "nudge-custom-function-registry": "static-1.3053",
  "nudge-renderer-utils": "static-1.3372",
  "whisper-core-api": "static-1.7512",
  "crm-record-cards-service-types": "static-1.3833",
  "highcharts": "static-8.114",
  "trellis-story-utils": "static-1.4913",
  "storybook-react": "static-1.43",
  "flux-actions": "static-1.378",
  "integrations-error-boundary-lib": "static-1.14690",
  "integrations-tracking-lib": "static-1.6017",
  "native-integrations-shared-strings": "static-1.8168",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10776",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1114",
  "InboxConnectUtils": "static-4.15726",
  "meetings-connect-utils-lib": "static-1.8021",
  "calling-orchestration-schema": "static-1.37067",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16543",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.15263",
  "universal-page-editor-lib": "static-1.3416",
  "adobe-sign-auth-lib": "static-1.644",
  "ads-unified-auth-lib": "static-1.1725",
  "custom-vendor-connection-lib": "static-1.164",
  "google-sheets-integration-lib": "static-1.1208",
  "microsoft-drive-auth-lib": "static-1.371",
  "surveymonkey-integration-lib": "static-1.725",
  "slack-ui-library": "static-1.10804",
  "hub-http-contrib": "static-1.3432",
  "ui-addon-sales-email": "static-1.5609",
  "academy-service-client": "static-1.4100",
  "croppie": "static-2.10",
  "final-form": "static-1.81",
  "SafeStorage": "static-1.4801",
  "trellis-ecosystem": "static-1.7757",
  "wootric-nps": "static-1.7259",
  "marketplace-ui-apps-core": "static-1.19469",
  "marketplace-ui-common": "static-1.20937",
  "developer-experience-shared-components": "static-1.10943",
  "immutable-less": "static-1.5056",
  "marketplace-ui-client-types": "static-1.18344",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4323",
  "ai-settings-ui-library": "static-1.8478",
  "nav-meta": "static-1.30670",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1390",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12935",
  "simple-data-table": "static-1.3700"
},
  depPathPrefixes: {
  "deal-plans-ui": "/deal-plans-ui/static-1.2310",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.505",
  "diff": "/diff/static-1.7",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26371",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5995",
  "hs-test-utils": "/hs-test-utils/static-1.8445",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10781",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11898",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6853",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.25",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7578",
  "react-colorpicker": "/react-colorpicker/static-2.10618",
  "react-dlb": "/react-dlb/static-1.92",
  "react-utils": "/react-utils/static-2.5619",
  "reselect": "/reselect/static-3.15",
  "rich-text-lib": "/rich-text-lib/static-1.20451",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18502",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6035",
  "avatar-components": "/avatar-components/static-1.2889",
  "data-fetching-client": "/data-fetching-client/static-1.10052",
  "deal-plans-lib": "/deal-plans-lib/static-1.1591",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10274",
  "FileManagerLib": "/FileManagerLib/static-1.40357",
  "foundations-assets": "/foundations-assets/static-1.5293",
  "foundations-components": "/foundations-components/static-1.8642",
  "foundations-theming": "/foundations-theming/static-1.4884",
  "framer-motion": "/framer-motion/static-1.82",
  "hub-http": "/hub-http/static-1.6615",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19158",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "I18n": "/I18n/static-7.1691",
  "js-cookie": "/js-cookie/static-1.18",
  "payment-link-components": "/payment-link-components/static-1.24304",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1615",
  "quartz-auth": "/quartz-auth/static-1.1253",
  "quartz-config": "/quartz-config/static-1.1356",
  "quartz-core": "/quartz-core/static-1.6797",
  "quartz-routing": "/quartz-routing/static-1.1008",
  "quick-fetch": "/quick-fetch/static-1.4187",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "rpc-client-utils": "/rpc-client-utils/static-1.5073",
  "sanitize-text": "/sanitize-text/static-1.8563",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11553",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9935",
  "UIComponents": "/UIComponents/static-3.8844",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3855",
  "quartz-webpack": "/quartz-webpack/static-1.3802",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.656",
  "customer-data-objects": "/customer-data-objects/static-1.8099",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8325",
  "graphql": "/graphql/static-1.92",
  "laboratory-lib": "/laboratory-lib/static-3.7556",
  "onboarding-scopes": "/onboarding-scopes/static-1.6858",
  "seat-types-lib": "/seat-types-lib/static-1.919",
  "ui-addon-opt": "/ui-addon-opt/static-4.8779",
  "usage-tracker": "/usage-tracker/static-1.7719",
  "usage-tracker-core": "/usage-tracker-core/static-1.7569",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3556",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "ts-schema": "/ts-schema/static-1.4357",
  "webpack-env": "/webpack-env/static-1.54",
  "jasmine": "/jasmine/static-4.4715",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "hs-story-utils": "/hs-story-utils/static-1.9831",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "data-token-picker": "/data-token-picker/static-1.17028",
  "icons": "/icons/static-2.699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3294",
  "property-translator": "/property-translator/static-1.5787",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8510",
  "cssUtils": "/cssUtils/static-1.1027",
  "HubStyle": "/HubStyle/static-2.12205",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6550",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6125",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5151",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4923",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "crm-message-bus": "/crm-message-bus/static-1.43958",
  "property-value-citations": "/property-value-citations/static-1.3469",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9502",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9903",
  "audio-components": "/audio-components/static-1.6478",
  "file-manager-components": "/file-manager-components/static-1.24717",
  "FileManagerCore": "/FileManagerCore/static-1.40216",
  "FileManagerImages": "/FileManagerImages/static-1.37868",
  "quartz-i18n": "/quartz-i18n/static-1.1253",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux-thunk": "/redux-thunk/static-2.83",
  "video-components": "/video-components/static-1.14319",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4911",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2600",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.116",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2924",
  "ui-fonts": "/ui-fonts/static-1.1160",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3367",
  "foundations-theming-base": "/foundations-theming-base/static-1.3869",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.357",
  "content-assistance-lib": "/content-assistance-lib/static-1.8330",
  "content-media-capture": "/content-media-capture/static-1.5651",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10238",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10679",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6764",
  "customer-data-properties": "/customer-data-properties/static-1.52855",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19437",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5489",
  "onboarding-tours": "/onboarding-tours/static-1.17288",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3936",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9485",
  "user-context": "/user-context/static-1.5476",
  "pdf-js": "/pdf-js/static-2.49",
  "interframe": "/interframe/static-3.5148",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6133",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10779",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.190",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.565",
  "quartz-head": "/quartz-head/static-1.1243",
  "quartz-test": "/quartz-test/static-1.1253",
  "quartz-tracking": "/quartz-tracking/static-1.957",
  "trellis-components": "/trellis-components/static-1.2943",
  "usage-tracker-container": "/usage-tracker-container/static-1.7709",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.483",
  "chirp-fetch": "/chirp-fetch/static-1.2306",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4877",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4105",
  "superstore": "/superstore/static-1.5164",
  "feedback-loader": "/feedback-loader/static-1.29955",
  "sassPrefix": "/sassPrefix/static-1.295",
  "batch-promise": "/batch-promise/static-1.1951",
  "external-options-client-types": "/external-options-client-types/static-1.4405",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7302",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1667",
  "purchase-motions-api": "/purchase-motions-api/static-1.6553",
  "signup-constants": "/signup-constants/static-1.19809",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8465",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.81",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1886",
  "crm-links": "/crm-links/static-1.6708",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13435",
  "hs-resources": "/hs-resources/static-1.601",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3737",
  "pulse": "/pulse/static-1.1044",
  "smart-property-lib": "/smart-property-lib/static-1.8503",
  "atom": "/atom/static-1.5484",
  "magpie-lib": "/magpie-lib/static-1.5842",
  "navigation-messaging": "/navigation-messaging/static-1.8360",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.8586",
  "chatspot-core": "/chatspot-core/static-1.23444",
  "ContentUtils": "/ContentUtils/static-1.69322",
  "copilot-toolkit": "/copilot-toolkit/static-1.12022",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1982",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5018",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4549",
  "poll-commands": "/poll-commands/static-1.3878",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.648",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.665",
  "ui-universal-auth": "/ui-universal-auth/static-1.9600",
  "urlinator": "/urlinator/static-1.4922",
  "video-embed": "/video-embed/static-1.36809",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "social-insights-client-types": "/social-insights-client-types/static-1.22812",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1386",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29485",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13455",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4831",
  "react-dnd-compat": "/react-dnd-compat/static-1.5018",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "content-media-compositions": "/content-media-compositions/static-2.17462",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5302",
  "media-bridge-lib": "/media-bridge-lib/static-1.19542",
  "commerce-products-lib": "/commerce-products-lib/static-1.10741",
  "growth-data-modal": "/growth-data-modal/static-1.6032",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5280",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5503",
  "calling-global-api": "/calling-global-api/static-1.65940",
  "calling-internal-common": "/calling-internal-common/static-1.31728",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67322",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59615",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4079",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4665",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4410",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10108",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8463",
  "formula-editor": "/formula-editor/static-1.14920",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4486",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1043",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3974",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49889",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4246",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.328",
  "tiered-pricing": "/tiered-pricing/static-1.2121",
  "topics-actions-lib": "/topics-actions-lib/static-1.581",
  "trial-components-library": "/trial-components-library/static-1.14279",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "zustand": "/zustand/static-1.87",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3470",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2865",
  "navigation-components": "/navigation-components/static-1.19033",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1355",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8060",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18555",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6136",
  "usage-tracker-public": "/usage-tracker-public/static-1.7530",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.107",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5405",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "nudge-client-utils": "/nudge-client-utils/static-1.3296",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.421",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4285",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7207",
  "persist-promise": "/persist-promise/static-1.4108",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10294",
  "event-emitter": "/event-emitter/static-1.1365",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.547",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "data-agent-kit": "/data-agent-kit/static-1.790",
  "markdown-it": "/markdown-it/static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10864",
  "fsm": "/fsm/static-1.4160",
  "policy-lib": "/policy-lib/static-1.7212",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10927",
  "reactive-lib": "/reactive-lib/static-1.1128",
  "simple-logging-lib": "/simple-logging-lib/static-1.3458",
  "cms-field-types": "/cms-field-types/static-1.5218",
  "integrations-lib": "/integrations-lib/static-1.17275",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.960",
  "breeze-engine-core": "/breeze-engine-core/static-1.1260",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1396",
  "outpost": "/outpost/static-1.4541",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6990",
  "commerce-permissions": "/commerce-permissions/static-1.1183",
  "customer-data-tracking": "/customer-data-tracking/static-1.7278",
  "products-iframe-lib": "/products-iframe-lib/static-1.8759",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11163",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2717",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.739",
  "calling-error-reporting": "/calling-error-reporting/static-1.31735",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11446",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6942",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2290",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6853",
  "sales-views-client-types": "/sales-views-client-types/static-1.4664",
  "bark-lib": "/bark-lib/static-1.16936",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6295",
  "react-codemirror": "/react-codemirror/static-1.11046",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15803",
  "hubs-service-types": "/hubs-service-types/static-1.1669",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2893",
  "user-context-client": "/user-context-client/static-1.4915",
  "nest": "/nest/static-1.642",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3053",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3372",
  "whisper-core-api": "/whisper-core-api/static-1.7512",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3833",
  "highcharts": "/highcharts/static-8.114",
  "trellis-story-utils": "/trellis-story-utils/static-1.4913",
  "storybook-react": "/storybook-react/static-1.43",
  "flux-actions": "/flux-actions/static-1.378",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14690",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6017",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8168",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10776",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1114",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15726",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8021",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37067",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16543",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.15263",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3416",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.644",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1725",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.164",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1208",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.371",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.725",
  "slack-ui-library": "/slack-ui-library/static-1.10804",
  "hub-http-contrib": "/hub-http-contrib/static-1.3432",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5609",
  "academy-service-client": "/academy-service-client/static-1.4100",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.81",
  "SafeStorage": "/SafeStorage/static-1.4801",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7757",
  "wootric-nps": "/wootric-nps/static-1.7259",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19469",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20937",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10943",
  "immutable-less": "/immutable-less/static-1.5056",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18344",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4323",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8478",
  "nav-meta": "/nav-meta/static-1.30670",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1390",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12935",
  "simple-data-table": "/simple-data-table/static-1.3700"
}
};
